import { Box, Chip, Stack, Typography, Table, TableBody, TableCell, TableRow, TableContainer } from '@mui/material';
import dayjs from 'dayjs';
import Paper from '@mui/material/Paper';

const typeConfig = { feature: { label: 'Nuevo', color: 'success2' }, fix: { label: 'Mejora', color: 'primary2' } };

const sortList = (list) => {
  return list.sort((a, b) => new Date(b.date) - new Date(a.date));
};

export default function ChangelogView({ data, lastSeenUpgrade }) {
  if (!data?.length) {
    return (
      <Box p={2}>
        <Typography variant="h6">Novedades</Typography>
        <Typography variant="body2" color="text.secondary">
          {' '}
          Aún no hay cambios publicados.{' '}
        </Typography>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom mb={6}>
          {' '}
          Últimos cambios{' '}
        </Typography>
      </Stack>
      <TableContainer component={Paper} variant="outlined">
        <Table sx={{ '& .MuiTableCell-root': { padding: { xs: '8px 16px', md: '20px' } } }}>
          <TableBody>
            {sortList(data).slice(0, 10).map((row) => {
              const isNew = !lastSeenUpgrade || row.date > lastSeenUpgrade;
              return (
                <TableRow key={`${row.date}-${row.title}`} sx={{ bgcolor: isNew ? 'background.paper' : 'background.default' }}>
                  <TableCell sx={{ color: isNew ? 'text.primary' : 'text.secondary' }} align="center" width="10%">
                    {dayjs(row.date).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell align="center" width="10%">
                    <Chip
                      label={
                        <>
                          <Box
                            component="span"
                            sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'inline' } }}
                          >
                            {typeConfig[row.type].label}
                          </Box>
                          <Box component="span" sx={{ display: { md: 'inline', lg: 'inline', xl: 'none' } }}>
                            {typeConfig[row.type].label.charAt(0)}
                          </Box>
                        </>
                      }
                      color={typeConfig[row.type].color}
                      variant="outlined"
                      size="small"
                      sx={{
                        width: { xs: 'auto', lg: '90%' },
                        minWidth: { xs: '32px', lg: 'auto' }, // Asegura que sea circular si es solo una letra
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ color: isNew ? 'text.primary' : 'text.secondary', fontWeight: 'bold' }} width="15%">
                    {row.title}
                  </TableCell>
                  <TableCell
                    sx={{ color: isNew ? 'text.primary' : 'text.secondary', width: { xs: 'auto', lg: '65%' } }}
                  >
                    <Box
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: '1.5rem',
                        wordBreak: 'break-word',
                        width: 'max-content',
                        maxWidth: { xs: '50em', lg: '55em', xl: '60em' },
                      }}
                    >
                      {row.text}
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
